import {getToken, removeToken, setToken, setUsername, removeUsername} from '@/utils/auth'
// import {getUserInfo, login, logout} from '@/api/login'
import store from '@/store'
import router from '@/router'
import {default as api} from '@/utils/request'

const user = {
  state: {
    token:'',
    username: '',
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, userInfo) => {
      state.username = userInfo.username
    },
    RESET_USER: (state) => {
      state.username = ''
      state.token = ''
    }
  },
  actions: {
    // 登录
    Login({commit, state}, loginForm) {
      return new Promise((resolve, reject) => {
        api({
          url: '/api/auth/admin_login',
          method: 'post',
          data: loginForm
        }).then(res => {
          if (!res.hasOwnProperty('code') || (res.hasOwnProperty('code') && res.code === 0)) {
            setToken(res.data.token)
            setUsername(res.data.userInfo.username)
            commit('SET_USER', res.data.userInfo)
            commit('SET_TOKEN', res.data.token)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 前端 登出
    FedLogOut({commit}) {
      return new Promise(resolve => {
        commit('RESET_USER')
        removeToken()
        removeUsername()
        resolve()
      })
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js